import type { RouterOptions } from '@nuxt/schema';

export default <RouterOptions> {
  // scrollBehavior(to, _from, savedPosition) {
  //   const nuxtApp = useNuxtApp();
  //   return new Promise((resolve, _reject) => {
  //     nuxtApp.hooks.hookOnce('page:finish', async () => {
  //       await nextTick();
  //       if (savedPosition) {
  //         savedPosition.behavior = 'smooth';
  //         resolve(savedPosition);
  //       }
  //       else {
  //         if (to.hash) {
  //           resolve({
  //             el: to.hash,
  //             top: 0,
  //           });
  //         }
  //         else {
  //           resolve({ top: 0 });
  //         }
  //       }
  //     });
  //   });
  // },
};
